import { render, staticRenderFns } from "./VaListLabel.vue?vue&type=template&id=63b05138&"
import script from "./VaListLabel.vue?vue&type=script&lang=js&"
export * from "./VaListLabel.vue?vue&type=script&lang=js&"
import style0 from "./VaListLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports